var callbacks = [];
var player;

var src="//players.brightcove.net/1509317113/VkZ4EROte_default/index.min.js";
var script = document.createElement("script");
script.src = src;
script.onload = function() {
  var ready = false;
  player = videojs("bc-player");
  if (player.readyState() == 0) {
    ready = true;
    callbacks.forEach(fn => fn(player));
  } else {
    player.ready(function() {
      ready = true;
      callbacks.forEach(fn => fn(player));
    });
  }
  var tick = function() {
    if (ready) return;
    if (player.catalog) {
      callbacks.forEach(fn => fn(player));
    } else {
      setTimeout(tick, 500);
    }
  };
  setTimeout(tick, 1000);
};
document.head.appendChild(script);

module.exports = function(fn) {
  if (player) {
    return fn(player);
  }
  callbacks.push(fn);
};